import { AppThunk, AppDispatch } from "../../types";
import { push } from "connected-react-router";
import { ROOT_PATH } from "../../../routing/paths";
import { SET_AUTH } from "..";

export type DestroySession = () => void;

const destroySessions = (): AppThunk => async (dispatch: AppDispatch) => {
  localStorage.removeItem("jwt");
  dispatch({ type: SET_AUTH, payload: { logged: false, role: null } });
  dispatch(push(ROOT_PATH));
};

export default destroySessions;
